import { inheritSerialization } from 'cerialize';
import { AbstractType } from './abstract-type';

@inheritSerialization(AbstractType)
export class OrganizationType extends AbstractType {}
